import PageSignUp from "./SignUp";

export default PageSignUp;
